import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import {ByPassExpenseHeader} from './ByPassExpenseHeader';
import {ByPassExpenseGrid} from './ByPassExpenseGrid';
import {bypassExpenseStateSelector} from '../../pages/bypass-expense/redux/selectors';
import {CircularProgress} from '@mui/material';
import {Box} from '@mui/system';

export const ByPassExpenseContent = () => {
  const isLoading = useSelector(bypassExpenseStateSelector.getIsLoading());
  const [filterParams, setFilterParams] = useState<any>(null);

  return (
    <React.Fragment>
      <ByPassExpenseHeader onSearch={setFilterParams} />
      {isLoading && (
        <Box display={'flex'} justifyContent={'center'}>
          <CircularProgress />
        </Box>
      )}
      {filterParams && <ByPassExpenseGrid filterParams={filterParams} />}
    </React.Fragment>
  );
};
